export default __webpack_public_path__ + "static/media/checkpoint.d152b838.mp3";